module.exports = __webpack_public_path__ + "img/pack_basic.eeabe2d7.png";